/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPray = createReactComponent("outline", "pray", "IconPray", [["path", { "d": "M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0", "key": "svg-0" }], ["path", { "d": "M7 20h8l-4 -4v-7l4 3l2 -2", "key": "svg-1" }]]);

export { IconPray as default };
//# sourceMappingURL=IconPray.mjs.map
